import styled from '@emotion/styled/macro';
import { theme } from 'styles/theme';

export const InputWrapper = styled.div`
  margin-bottom: ${theme.space[6]};
`;
